import React from "react";
import Menu from "../components/Menu";
function Portfolio() {
  return (
    <div>
      <iframe
        title="portfolio file"
        className="vh-100"
        width="100%"
        src="https://embed.figma.com/design/nln69aUfX1DuXxnMWekCJC/SOME-WORKS?node-id=0-1&embed-host=share"
        allowfullscreen
      ></iframe>
      <Menu></Menu>
    </div>
  );
}

export default Portfolio;
